import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React__default, { useRef, useState, useCallback, useLayoutEffect } from 'react';
import { useResizeDetector } from 'react-resize-detector/build/withPolyfill';
import { classnames } from '../../../utils/classnames.js';
import Chip from '../Chip/Chip.js';
import Tooltip from '../Tooltip/Tooltip.js';
import './InputChipsBase.scss.js';

var InputChipsBase = function InputChipsBase(props) {
  var chips = props.chips,
      multiline = props.multiline,
      disabled = props.disabled,
      hideAll = props.hideAll,
      children = props.children,
      onChipRemove = props.onChipRemove,
      onContainerClick = props.onContainerClick;
  var containerRef = useRef(null);
  var tagsRef = useRef(null);

  var _useState = useState(Infinity),
      _useState2 = _slicedToArray(_useState, 2),
      visibleCountState = _useState2[0],
      setVisibleCount = _useState2[1];

  var visibleCount = hideAll ? 0 : visibleCountState;
  var measureChips = useCallback(function () {
    if (multiline) {
      return;
    }

    var rootDiv = containerRef.current;

    if (!rootDiv || !tagsRef.current) {
      return;
    }

    var chipDivs = tagsRef.current.querySelectorAll('[data-tag]');
    var maxWidth = rootDiv.clientWidth;

    if (children) {
      var inputWidth = 50;
      maxWidth -= inputWidth;
    }

    var moreDiv = rootDiv.querySelector('[data-more]');

    if (moreDiv) {
      maxWidth -= moreDiv.clientWidth;
    }

    var width = 0;
    var count = 0;

    for (var _i = 0, _Array$from = Array.from(chipDivs); _i < _Array$from.length; _i++) {
      var chip = _Array$from[_i];
      width += chip.clientWidth;

      if (width <= maxWidth) {
        count++;
      } else {
        setVisibleCount(count);
        break;
      }
    }
  }, [multiline, children]);
  var onResize = useCallback(function () {
    if (visibleCount === Infinity) {
      measureChips();
    } else {
      setVisibleCount(Infinity);
    }
  }, [measureChips, visibleCount]);
  useResizeDetector({
    targetRef: containerRef,
    refreshMode: 'throttle',
    refreshRate: 300,
    onResize: onResize
  });
  useLayoutEffect(measureChips);
  var chipsJsx = chips.map(function (chip, index) {
    var hidden = index + 1 > visibleCount;
    return /*#__PURE__*/React__default.createElement("div", {
      key: chip.value,
      "data-tag": true,
      className: classnames({
        'rf-input-chips-base__tag': true,
        'rf-input-chips-base__tag_hidden': hidden
      }),
      "data-v-6e52f9c7": ""
    }, /*#__PURE__*/React__default.createElement(Chip, {
      type: "secondary",
      size: "xs",
      disabled: disabled,
      maxLength: 15,
      onClick: function onClick() {
        return undefined;
      },
      onRemove: function onRemove() {
        return onChipRemove(chip, index);
      },
      "data-v-6e52f9c7": ""
    }, chip.label));
  });
  var hiddenChips = chips.slice(visibleCount);
  var moreChip = !!hiddenChips.length && /*#__PURE__*/React__default.createElement(Tooltip, {
    position: "bottom",
    hidePadding: true,
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement("div", {
    "data-more": true,
    className: "rf-input-chips-base__tag",
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement(Chip, {
    type: "secondary",
    size: "xs",
    onClick: function onClick() {
      return undefined;
    },
    "data-v-6e52f9c7": ""
  }, "+", chips.length - visibleCount)), /*#__PURE__*/React__default.createElement("div", {
    className: "rf-input-chips-base__popper",
    "data-v-6e52f9c7": ""
  }, hiddenChips.map(function (chip, index) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: chip.value,
      className: "rf-input-chips-base__tag",
      "data-v-6e52f9c7": ""
    }, /*#__PURE__*/React__default.createElement(Chip, {
      type: "secondary",
      size: "xs",
      disabled: disabled,
      onClick: function onClick() {
        return undefined;
      },
      onRemove: function onRemove() {
        return onChipRemove(chip, index);
      },
      "data-v-6e52f9c7": ""
    }, chip.label));
  })));
  return /*#__PURE__*/React__default.createElement("div", {
    className: "rf-input-chips-base__tags-container",
    ref: containerRef,
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classnames('rf-input-chips-base__tags', multiline && 'rf-input-chips-base__tags_multiline'),
    onClick: onContainerClick,
    ref: tagsRef,
    "data-v-6e52f9c7": ""
  }, chipsJsx, moreChip, children && /*#__PURE__*/React__default.createElement("div", {
    className: "rf-input-chips-base__input-wrapper",
    "data-v-6e52f9c7": ""
  }, children)));
};

export { InputChipsBase as default };
